import {
    PAYMENT_POPUP_STATUS_CHANGE, FETCH_ALL_PAYMENT_SUCCESS, SET_PAYMENT,
    UPDATE_PAYMENT_SUCCESS, PAYMENT_BULK_UPDATE_POPUP_STATUS_CHANGE,
    PAYMENT_ADD_PAYMENT_POPUP_STATUS_CHANGE, CREATE_PAYMENT_SUCCESS,
    FILTER_PAYMENT_SUCCESS, UPDATE_BULK_SUCCESS, INIT_PAYMENT,
    CHANGE_SELECT_ALL_STATUS, ON_CHANGE_PAGE_CHECKED_PAYMENT_LIST, ON_CHANGE_UNCHECKED_PAYMENT_LIST,
    ON_CHANGE_NON_SELECT_ALL_CHECKED_PAYMENT_LIST,
} from "constants/payments.constants";
import { FETCH_PAYMENT_TYPES_SUCCESS } from "constants/payementType.constants";

const INIT_STATE = {
    payments: [],
    payment_types: [],
    payment: {
        id: 0,
        patient_id: 0,
        patient_full_name: "",
        doctor_id: 0,
        doctor_full_name: "",
        domain_id: 0,
        domain_name: "",
        payment_type: null,
        amount_to_be_paid_to_doctor: 0,
        payment_processed_time: new Date(),
        consultation_end_time: null,
        is_verified: false,
        remark: "",
    },
    pagination: {
        current_page: 1,
        page_size: 0,
        total: 0,
        next_page: false,
        total_pages: 0,
    },
    view_popup_open: false,
    bulk_update_popup_open: false,
    add_payment_popup_open: false,
    bulk_update_popup_data: [],
    View_popup_data: {},
    select_all_status: false,
    page_checked_payment_list: [],
    unchecked_payment_list: [],
    non_select_all_checked_payment_list: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_ALL_PAYMENT_SUCCESS: {
            return {
                ...state,
                payments: action.payload.data,
                pagination: action.payload.paginate,
                page_checked_payment_list: getPageCheckedList(state.select_all_status, action.payload.data, state.unchecked_payment_list, state.non_select_all_checked_payment_list),
            }
        }
        case FILTER_PAYMENT_SUCCESS: {
            return {
                ...state,
                payments: action.payload.data,
                pagination: action.payload.paginate,
                page_checked_payment_list: getPageCheckedList(state.select_all_status, action.payload.data, state.unchecked_payment_list, state.non_select_all_checked_payment_list),
            }
        }
        case PAYMENT_POPUP_STATUS_CHANGE: {
            return {
                ...state,
                view_popup_open: action.payload.status,
                View_popup_data: action.payload.status,
                payment: getEditContent(
                    INIT_STATE.payment,
                    state.payments.find((c) => c.id === action.payload.data)
                ),
            };
        }
        case PAYMENT_BULK_UPDATE_POPUP_STATUS_CHANGE: {
            return {
                ...state,
                bulk_update_popup_open: action.payload.status,
                bulk_update_popup_data: action.payload.data
            };
        }
        case SET_PAYMENT: {
            let c = Object.assign({}, state.payment);
            c[action.key] = action.value
            return {
                ...state,
                payment: c
            }
        }
        case INIT_PAYMENT: {
            return {
                ...state,
                payment: action.payload
            }
        }
        case UPDATE_PAYMENT_SUCCESS: {
            let foundIndex = state.payments.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.payments);
            all[foundIndex] = action.payload.data
            return {
                ...state,
                payments: all
            }
        }
        case UPDATE_BULK_SUCCESS: {
            let all = Object.assign([], state.payments);
            action.payload.data.forEach(element => {
                let foundIndex = state.payments.findIndex(x => x.id === element.id);
                all[foundIndex] = element
            });
            return {
                ...state,
                payments: all,
                select_all_status: INIT_STATE.select_all_status,
                page_checked_payment_list: INIT_STATE.page_checked_payment_list,
                unchecked_payment_list: INIT_STATE.unchecked_payment_list,
                non_select_all_checked_payment_list: INIT_STATE.non_select_all_checked_payment_list
            }
        }
        case CREATE_PAYMENT_SUCCESS: {
            let all = Object.assign([], state.payments);
            all.unshift(action.payload.data)
            return {
                ...state,
                payments: all,
                payment: getInitPaymentData()
            }
        }
        case CHANGE_SELECT_ALL_STATUS: {
            return {
                ...state,
                select_all_status: !state.select_all_status,
                unchecked_payment_list: !state.select_all_status === true ? state.unchecked_payment_list: [], // false give empty array
            }
        }
        case ON_CHANGE_PAGE_CHECKED_PAYMENT_LIST: {
            return {
                ...state,
                page_checked_payment_list: action.checked_array,
            }
        }
        case ON_CHANGE_UNCHECKED_PAYMENT_LIST: {
            let new_unchecked_payment_list = state.unchecked_payment_list;
            if(state.select_all_status) {
                // check id is there or not
                let value = state.unchecked_payment_list.filter((unchecked_payment)=> parseInt(unchecked_payment) === parseInt(action.id))[0];
                // if value undefined
                if(value === undefined && state.select_all_status) { //value not exist and select_all_status is only true
                    new_unchecked_payment_list.push(parseInt(action.id));
                }
            }
            return {
                ...state,
                unchecked_payment_list: new_unchecked_payment_list,
            }
        }
        case ON_CHANGE_NON_SELECT_ALL_CHECKED_PAYMENT_LIST: {
            return {
                ...state,
                non_select_all_checked_payment_list: action.checked_array,
            }
        }
        // payment_types
        case FETCH_PAYMENT_TYPES_SUCCESS: {
            return {
                ...state,
                payment_types: action.payment_types.data,
            }
        }
        default:
            return state;
    }
}

function getEditContent(initobject, o) {
    initobject.id = o.id;
    initobject.patient_id = o.patient_id;
    initobject.patient_full_name = o.patient_full_name;
    initobject.doctor_id = o.doctor_id;
    initobject.doctor_full_name = o.doctor_full_name;
    initobject.domain_id = o.domain_id;
    initobject.domain_name = o.domain_name;
    initobject.payment_type = o.payment_type;
    initobject.amount_to_be_paid_to_doctor = o.amount_to_be_paid_to_doctor;
    initobject.payment_processed_time = o.payment_processed_time;
    initobject.consultation_end_time = o.consultation_end_time;
    initobject.is_verified = o.is_verified;
    initobject.remark = o.remark;
    return initobject;
}

function getInitPaymentData() {
    let payment = {
        id: 0,
        patient_id: 0,
        patient_full_name: "",
        doctor_id: 0,
        doctor_full_name: "",
        domain_id: 0,
        domain_name: "",
        payment_type: null,
        amount_to_be_paid_to_doctor: 0,
        payment_processed_time: new Date(),
        consultation_end_time: null,
        is_verified: false,
        remark: "",
    }
    return payment;
}

function getPageCheckedList(select_all_status, payments , unchecked_payment_list, non_select_all_checked_payment_list) {
    let new_checked_items = [];
    if(select_all_status) {
        payments.forEach(payment => {
            // unchecked_payment_list_data filter
            let filter_unchecked_payment_list = unchecked_payment_list.filter((unchecked_payment)=> parseInt(unchecked_payment) === parseInt(payment.id))[0];
            if(filter_unchecked_payment_list === undefined) {
                new_checked_items.push(parseInt(payment.id));
            }
        });
    }else {
        payments.forEach(payment => {
            // page_request_checked_list_data filter
            let filter_unchecked_payment_list = non_select_all_checked_payment_list.filter((non_select_all_checked_payment)=> parseInt(non_select_all_checked_payment) === parseInt(payment.id))[0];
            if(filter_unchecked_payment_list) {
                new_checked_items.push(parseInt(payment.id));
            }
        });
    }
    return new_checked_items;
}
